import routeConstant from "common/routeConstants";
import {
  requestNotificationPermission,
  storeFirebaseData,
} from "helpers/firebaseInit";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({
  component: Component,
  isAdminRoute = false,
  ...props
}) => {
  const tokenReducer = useSelector((state) => state.tokenReducer);
  const isAuthenticated = !!tokenReducer?.token;
  const profileReducerState = useSelector((state) => state.profileReducer);
  const { userData } = profileReducerState;
  const isAdminUser = userData?.isAdmin === 1;

  useEffect(() => {
    if (tokenReducer && tokenReducer.token) {
      requestNotificationPermission()
        .then((firebaseToken) => {
          return storeFirebaseData(firebaseToken);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  return (
    <Route
      {...props}
      render={(innerProps) => {
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: routeConstant.signup,
                state: { from: innerProps.location },
              }}
            />
          );
        }
        if (isAdminRoute && !isAdminUser) {
          return (
            <Redirect
              to={{
                pathname: routeConstant.projectList,
              }}
            />
          );
        }
        return <Component {...innerProps} />;
      }}
    />
  );
};
export default PrivateRoute;
